var _style, _circle, _g, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FCFCFC;}\n\t.st1{fill:#A2001D;}\n\t.st2{fill:#6DA544;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 256,
    r: 256
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M105.7,237.4L77.9,187l27.8-49.7l27.8,49.7L105.7,237.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.1,237.4L22.3,187l27.8-49.7L77.9,187L50.1,237.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M105.7,374.7l-27.8-50.5l27.8-49.7l27.8,49.7L105.7,374.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.1,374.7l-27.8-50.5l27.8-49.7l27.8,49.7L50.1,374.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M133.6,49.7l-7.9-14.1C111.6,44,98.3,53.7,86.1,64.5l19.6,35.6L133.6,49.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M105.7,411.8l-19.9,35.5c12.2,10.9,25.4,20.6,39.6,29l8.1-14.7L105.7,411.8z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M155.8,322.8v168.9C186.6,504.7,220.4,512,256,512c110.1,0,203.9-69.5,240.1-167L155.8,322.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M496.1,345c10.3-27.7,15.9-57.7,15.9-89C512,114.6,397.4,0,256,0c-35.5,0-69.4,7.3-100.2,20.3V345L496.1,345 L496.1,345z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBy);
export default __webpack_public_path__ + "static/media/by.539b0025b194f9eb4f57c6c7dcc2210b.svg";
export { ForwardRef as ReactComponent };